import m from "mithril";
import {elementId} from './helpers'
import {TextboxItem} from '../../model/items/textbox'

function getHtmlInputType(type?: string): string {
    switch (type) {
        case 'NUMERIC': return 'number';
        case 'NUMERIC_RANGE': return 'number';
        case 'NUMERIC_DECIMAL': return 'number';
        case 'EMAIL': return 'email';
    }
    return 'text';
}

function getHtmlInputStep(type?: string): string|null {
    switch (type) {
        case 'NUMERIC': return '1';
        case 'NUMERIC_RANGE': return 'any';
        case 'NUMERIC_DECIMAL': return 'any';
    }
    return '';
}

let focused = false;

export function textboxItemView(c:TextboxItem) {
    const tagType = c.childrenTags?.[0]?.attributes?.type;
    const type = getHtmlInputType(tagType);
    const step = getHtmlInputStep(tagType);

    const onChange = (e: KeyboardEvent) => {

        const currentTarget = <HTMLInputElement>(e.currentTarget ?? e.target);
        let value = String(currentTarget.value ?? "");
        if (type === 'number') {
            value = value.replace(',', '.');
        }
        c.set.bind(c)(value);
    }

    return m('.textbox.fs-'+c.fontSize.toLowerCase()+(c.labelLeft?'.has-label-left':'')+(c.labelRight?'.has-label-right':''), {
        style: {
            width: typeof c.defaultWidthPercent === "number" ? c.defaultWidthPercent+'%' : '',
        }
    }, [
        c.labelLeft ? m('.label-left', {}, m.trust(c.labelLeft)) : null,
        m('.textbox-input'+(c.iconLeft?'.has-icon-left':'')+(c.iconRight?'.has-icon-right':''), {}, [
            c.iconLeft ? m('i.icon-left.bi.bi-'+c.iconLeft) : null,
            m(`input[type=${type}][step=${step}]`, {
                id: elementId(c, c.cell.id),
                onfocus: () => focused = true,
                onblur: () => focused = false,
                onchange: onChange,
                oninput: onChange,
                value: focused ? undefined : (c.getVariable() ?? ""),
                disabled: !c.cell.enabled,
                autocomplete: 'off',
            }),
            c.iconRight ? m('i.icon-right.bi.bi-'+c.iconRight) : null,
        ]),
        c.labelRight ? m('.label-right', {}, m.trust(c.labelRight)) : null,
	]);
}
